import React from 'react';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcStepProgressBar from 'components/molecules/PcStepProgressBar';
import PcInputTitle from 'components/molecules/PcInputTitle';
import PcFreeInputArea from 'components/molecules/PcFreeInputArea';
import PcPointComment from 'components/molecules/PcPointComment';
import PcInputItem from 'components/molecules/PcInputItem';
import PcModal from 'components/molecules/PcModal';
import PcErrorArea from 'components/molecules/PcErrorArea';
import './index.pc.scss';

import {
  POINT_COMMENT_MAP
} from 'utils/constant';

const PresentPC = ({
  dutyDip,
  workInfoContentDip,
  workInfoContentCmntDip,
  workInfoContentModal,
  onClickMainButton,
  isApiError,
  valid
}) => (
  <div className="AddJobDescription PC">
    <PcBasicTemplate
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      valid={valid}
    >
      <PcStepProgressBar currentStep={3}></PcStepProgressBar>
      <div className='titleArea'>
        <div className='title'>
          職種・業務内容
        </div>
      </div>
      <div id="jd" className="contents mT60">
        <PcPointComment labelList={POINT_COMMENT_MAP.jdPointCmnt.labelList} pattern={POINT_COMMENT_MAP.jdPointCmnt.pattern} />
        <div className="jd">
          <PcInputTitle
            title={dutyDip.title}
            label={dutyDip.label}
            subTitle={dutyDip.subTitle}
            list={dutyDip.list}
            type={dutyDip.type}
            comment={!dutyDip.comment ? (<></>) : (
              <>
                <PcFreeInputArea
                  visible={dutyDip.comment.visible}
                  title={dutyDip.comment.title}
                  label={dutyDip.comment.label}
                  questionMark={dutyDip.comment.questionMark}
                  popUpTitle={dutyDip.comment.popUpTitle}
                  popUpDetail={dutyDip.comment.popUpDetail}
                  relativePosArrow={dutyDip.comment.relativePosArrow}
                  name={dutyDip.comment.name}
                  textAreaValue={dutyDip.comment.textAreaValue}
                  cmntOnChange={dutyDip.comment.cmntOnChange}
                  onInput={dutyDip.comment.onInput}
                  onCompositionEnd={dutyDip.comment.onCompositionEnd}
                  maxLength={dutyDip.comment.maxLength}
                  placeholder={dutyDip.comment.placeholder}
                  rows={dutyDip.comment.rows}
                  cols={dutyDip.comment.cols}
                  wordCount={dutyDip.comment.wordCount}
                  errMessage={dutyDip.comment.errMessage}
                  inValid={dutyDip.comment.inValid}
                />
              </>
            )}
          />
          <div className='line'></div>
          <div id='workInfoContentDip'>
            <PcInputItem
              title={workInfoContentDip.title}
              label={workInfoContentDip.label}
              subTitle={workInfoContentDip.subTitle}
              questionMark={false}
            >
              {workInfoContentDip.list}
            </PcInputItem>
            <PcModal
              modalIsOpen={workInfoContentModal.modalIsOpen}
              content={workInfoContentModal.content}
              button={workInfoContentModal.button}
              onClickCloseButton={workInfoContentModal.onClickCloseButton}
              onClickBackButton={workInfoContentModal.onClickBackButton}
              max={workInfoContentModal.max}
              current={workInfoContentModal.current}
              mdName={workInfoContentModal.mdName}
              mdNote={workInfoContentModal.mdNote}
              style={workInfoContentModal.style}
            />
          </div>
          <div id='workInfoContentCmntDip'>
            <PcInputTitle
              title={workInfoContentCmntDip.title}
              label={workInfoContentCmntDip.label}
              list={workInfoContentCmntDip.list}
              type={workInfoContentCmntDip.type}
            />
            <span className=''>
              <PcErrorArea position='relative' message={workInfoContentCmntDip.errMessage} />
            </span>
          </div>
        </div>
      </div>
    </PcBasicTemplate>
  </div>
);

export default PresentPC;